import React from "react";
import { Box } from "@mui/material";
import testimonialImage from "../../images/zforher-testimonial.png";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', serif" };

const TESTIMONIALS = [
  {
    image: testimonialImage,
    quote:
      "Ada runs a small provisions store in Onitsha. With Z-ForHer, she was able to restock faster during peak periods without waiting for extra cash.",
    name: "Ada",
    role: "Shop Owner",
  },
  {
    image: testimonialImage,
    quote:
      "Ada runs a small provisions store in Onitsha. With Z-ForHer, she was able to restock faster during peak periods without waiting for extra cash.",
    name: "Ada",
    role: "Shop Owner",
  },
  {
    image: testimonialImage,
    quote:
      "Ada runs a small provisions store in Onitsha. With Z-ForHer, she was able to restock faster during peak periods without waiting for extra cash.",
    name: "Ada",
    role: "Shop Owner",
  },
];

const TestimonialCard = ({ image, quote, name, role }) => (
  <div
    className="flex flex-col sm:w-full"
    style={{ flex: "1 1 0", minWidth: 0, gap: "16px" }}
  >
    <div
      style={{
        position: "relative",
        width: "100%",
        aspectRatio: "1 / 1.05",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      <img
        src={image}
        alt={name}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.52)",
        }}
      />
      <p
        style={{
          ...raleway,
          fontWeight: 400,
          fontSize: "15px",
          lineHeight: 1.6,
          color: "#FFFFFF",
          position: "absolute",
          left: "24px",
          right: "24px",
          bottom: "24px",
          margin: 0,
        }}
      >
        {quote}
      </p>
    </div>
    <div
      style={{
        ...raleway,
        fontWeight: 500,
        fontSize: "15px",
        lineHeight: 1.4,
        color: "#132A22",
      }}
    >
      {name}, {role}
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <Box
      sx={{
        background: "#FFFFFF",
        boxSizing: "border-box",
        padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
        <div
          className="flex flex-col items-center text-center"
          style={{
            gap: "clamp(12px, 1.39vw, 20px)",
            marginBottom: "clamp(40px, 4.86vw, 70px)",
          }}
        >
          {/* Label */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#295B4A",
                flexShrink: 0,
                display: "inline-block",
              }}
            />
            <span
              style={{
                ...geistMono,
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: 1,
                letterSpacing: "0.1em",
                color: "#295B4A",
                textTransform: "uppercase",
              }}
            >
              Real Stories
            </span>
          </div>

          <h2
            style={{
              ...instrumentSerif,
              fontWeight: 400,
              fontSize: "clamp(28px, 4.17vw, 60px)",
              lineHeight: 1.1,
              letterSpacing: "-0.01em",
              color: "#132A22",
              margin: 0,
              maxWidth: "min(800px, 100%)",
            }}
          >
            Real women. Real business growth.
          </h2>

          <p
            style={{
              ...raleway,
              fontWeight: 400,
              fontSize: "clamp(14px, 1.25vw, 18px)",
              lineHeight: 1.6,
              color: "#3F5445",
              margin: 0,
              maxWidth: "min(520px, 100%)",
            }}
          >
            From traders to entrepreneurs, Zikora helps everyday people move
            forward.
          </p>
        </div>

        <div className="flex sm:flex-col" style={{ gap: "24px" }}>
          {TESTIMONIALS.map((t, i) => (
            <TestimonialCard key={i} {...t} />
          ))}
        </div>
      </div>
    </Box>
  );
};

export default Testimonials;
